<template>
  <div>
    <page-content-toolbar
      :projectName="`${project && project.name ? project.name : ' '}`"
      :title="$t('global.sourceViewer')"
    />

    <v-container fluid class="px-2 pt-0" >
      <div class="ma-8">
        <v-card
          elevation="2"
          class="mx-auto my-9"
        >
          <v-card-title v-on="loadingSources">{{ $t('sourceViewer.sourceViewer') }}</v-card-title>

          <v-card-text>
            <v-row class="mx-0">
              <v-col cols="6">
                <v-text-field
                  :label="$t('sourceViewer.sourceViewer')"
                  :value="source.version"
                  readonly
                />
              </v-col>
              <v-col cols="6">
                <raison-button
                  :disabled="!!source.deployment"
                  :button-label="$t('sourceViewer.deleteSource')"
                  :button-function="deleteSource"
                  :loading="deleting"
                >
                  <template v-slot:prepend>
                    <v-icon left>mdi-delete</v-icon>
                  </template>
                </raison-button>
              </v-col>
            </v-row>
            <v-row class="mx-0">
              <v-col cols="6">
                <v-text-field
                  :label="$t('sourceViewer.origin')"
                  :value="source.origin"
                  readonly
                />
              </v-col>
              <v-col cols="6">
                <raison-button
                  :button-label="$t('sourceViewer.downloadSource')"
                  :button-function="downloadSource"
                >
                  <template v-slot:prepend>
                    <v-icon left>mdi-download</v-icon>
                  </template>
                </raison-button>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12">
                <v-textarea
                  class="rai-sourceviewer__textarea"
                  :label="$t('sourceViewer.sourceCodes')"
                  :value="source.source"
                  solo
                  readonly
                  auto-grow
                />
              </v-col>
            </v-row>
           
          </v-card-text>
        </v-card>
      </div>
    </v-container>
  </div>
</template>

<script>
import PageContentToolbar from '@/components/layout/PageContentToolbar';
import RaisonButton from '@/components/global/RaisonButton';
import sourceService from '@/services/sources.js';

import projectPageMixin from '@/mixins/project-page-mixin.js';
import userRightMixin from '@/mixins/user-right-mixin.js';

export default {
  name: 'SourceViewer',

  components: { PageContentToolbar, RaisonButton },

  mixins: [ projectPageMixin, userRightMixin ],

  data () {
    return {
      source: {},
      loadingSources: false,
      deleting: false,
    };
  },

  methods: {
    deleteSource () {
      this.deleting = true;
      sourceService.deleteSource(this.project.id, this.source.id).then(res => {
        console.log('deleted', res);
        this.$router.push({ name: 'sourcesAndDeployments', params: { id: this.$route.params.id } });
      }).catch(err => {
        this.$emit('raison-event', { type: 'error', messages: [err] });
      }).finally(() => {
        this.deleting = false;
      });
    },

    downloadSource () {
      let element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(this.source.source));
      element.setAttribute('download', this.source.id + '.pl');

      element.style.display = 'none';
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },
    getSource() {
      const projectId = this.$route.params.id;
      const sourceId = this.$route.params.sourceId
      sourceService.getSource(projectId, sourceId).then(response => {
        if (response && response.data && response.data.source) {
          this.source = response.data;
          this.source.source = atob(this.source.source);
        } else if (response.data.message) {
          throw response.data.message;
        }
      }).catch(error => {
        this.$emit('raison-event', { type: 'error', messages: [error] });
      }).finally(() => {
        this.loadingSources = false;
      });
    },
  },

  created() {
    if (!this.isUserParameterizer) {
      this.$router.push({name: 'dashboard'});
    }

    this.loadingSources = false;
    this.getSource();
  },
}
</script>

<style>
.rai-sourceviewer__textarea {
  font-family: 'Courier New', Courier, monospace;
}
</style>